<template>
    <ValidationProvider 
        :name="field"
        :rules="rules"
        v-slot="{ errors }"
        slim
    >
        <v-textarea 
            v-model="textAreaValue" 
            :label="label" 
            :auto-grow="true"
            :rows="rows"
            :disabled="disabled"
            :class="withMargin ? 'ml-4 mr-4' : '' + ' v-textarea--base'" 
            row-height="30"  
            :alvqa="alvqa"  
            :error-messages="errors"
        >
            <template v-slot:append>
                <BaseTooltip v-if="iconTooltipText !== ''">
                    <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                    <template v-slot:text><span>{{ iconTooltipText }}</span></template>
                </BaseTooltip>
            </template>
        </v-textarea>
    </ValidationProvider>
</template>
<script>
import VTextarea from 'vuetify/es5/components/VTextarea'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "BaseEditPageTextarea",
    extends: VTextarea,
    components: {
        BaseTooltip
    },
    props: {
        context: String,
        field: String,
        iconTooltipText: {
            type: String,
            default: ''
        },
        alvqa: {
            type: String,
            default: ''
        },
        disabled:  {
            default: false
        },
        rules: {
            type: [Object, String],
            default: ""
        },
        rows: {
            type: String,
            default: "1"
        },
        withMargin: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        textAreaValue: {
            get() { return this.$store.getters['get'+ this.context + 'Details' + this.field] },
            set(value) { this.$store.commit('set' + this.context + 'Details' + this.field, value) }
        }
    }
}
</script>

<style>
/* no label, when used */
/* .v-textarea--base .v-text-field__slot {
    max-height: 150px;
    overflow: auto;
} */
/* .v-textarea--base .v-text-field__slot textarea {
    line-height: 25px !important;
} */
</style>